import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";
import axiosInstance from '../axiosInstance';

import "../css/template_custom.css";
import "../css/template_menu.css";
import "../libs/menu_js.js";
import '../libs/templates.js';
import '../libs/comments.js';
import "../libs/site_js.js";
import '../libs/lib-filter/lib-filter.css';
import '../libs/lib-filter/lib-filter.js';
import '../libs/form-validation.js';
import "../css/site_css.css";
import "../css/comunity.css";
import PrivateRoute from "../PrivateRoute";
import BackendHeader from '../component/BackendHeader';
import * as general from '../libs/general';

const AdminLayout = ({ children, roles = ['admin'] }) => {
  const currentUser = useSelector((state) => state.user.user);
  const [effectiveFlags, setEffectiveFlags] = useState({
    isAdmin: currentUser?.isAdmin === true,
    isMember: currentUser?.isMember === true,
  });
  const location = useLocation();
  const getClassActive = (source) => {
    var list = source.split('/');
    const pagePath = location.pathname.replace(/^\/|\/$/g, '');

    if (list.includes(pagePath)) return 'active';
    if (list.includes(pagePath + location.search)) return 'active';
    return '';
  };

  useEffect(() => {
    const handleEvent = () => { window.configLoaded = false; loadDataConfig(); };
    window.addEventListener('load-data-config', handleEvent);
    return () => { window.removeEventListener('load-data-config', handleEvent); };
  }, []);

  useEffect(() => {
    var menuClass = sessionStorage.getItem('menu_class');
    if (!menuClass) menuClass = 'nav-md';
    document.body.classList.add(menuClass);

    loadDataConfig();
  }, []);

  useEffect(() => {
    setEffectiveFlags({
      isAdmin: currentUser?.isAdmin === true,
      isMember: currentUser?.isMember === true,
    });
  }, [currentUser?.isAdmin, currentUser?.isMember]);

  useEffect(() => {
    let mounted = true;
    axiosInstance.get("/api/users/my-flags")
      .then((res) => {
        if (!mounted) return;
        const flags = res?.data?.data || {};
        setEffectiveFlags({
          isAdmin: flags.isAdmin === true,
          isMember: flags.isMember === true,
        });
      })
      .catch(() => {
        // keep local redux flags if endpoint unavailable
      });
    return () => {
      mounted = false;
    };
  }, []);
  const loadDataConfig = async () => {
    if (window.configLoaded) return;

    var requestApi = `/api/users/getConfig`;
    try {
      if (window.callingApi) return;
      window.callingApi = true;
      var response = await axiosInstance.get(requestApi);
      general.setLocalStorage("user_config", response.data.data);
      window.configLoaded = true;
      window.dispatchEvent(new Event("user-config-loaded"));

    } catch (error) {
      console.error(error);
    } finally {
      window.callingApi = false;
    }
  }

  const canAccessAdminLayout = effectiveFlags.isAdmin === true || effectiveFlags.isMember === true;
  if (!canAccessAdminLayout) {
    return <Navigate to="/trang-chu" replace />;
  }

  return (
    <div className="web-cover">
      <PrivateRoute roles={roles}>
        <BackendHeader />
        <div className="web-main relative">
          {children}
        </div>
      </PrivateRoute>
    </div>
  );
};

export default AdminLayout;